import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPercentageRange]'
})
export class PercentageRangeDirective {
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
    ];
    if (
      allowedKeys.includes(event.key) ||
      (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase()))
    ) {
      return;
    }

    // Block non-digit keys
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    // Predict the new value if this key is allowed
    const selectionStart = this.el.selectionStart || 0;
    const selectionEnd = this.el.selectionEnd || 0;
    const currentValue = this.el.value;
    const newValue = 
      currentValue.substring(0, selectionStart) + event.key + currentValue.substring(selectionEnd);

    const numericValue = Number(newValue);

    // Block if value is greater than 100 or equal to 0 (which would be invalid)
    if (numericValue > 100 || numericValue === 0) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pasteData = event.clipboardData?.getData('text/plain') || '';
    if (!/^\d+$/.test(pasteData)) {
      event.preventDefault();
      return;
    }
    const currentValue = this.el.value;
    const selectionStart = this.el.selectionStart || 0;
    const selectionEnd = this.el.selectionEnd || 0;
    const newValue =
      currentValue.substring(0, selectionStart) + pasteData + currentValue.substring(selectionEnd);

    if (Number(newValue) > 100 || Number(newValue) === 0) {
      event.preventDefault();
    }
  }

  @HostListener('blur')
  onBlur(): void {
    let val = Number(this.el.value);
    if (isNaN(val) || val < 1) {
      this.el.value = '1';
    } else if (val > 100) {
      this.el.value = '100';
    }
  }
}
